module.exports = __webpack_public_path__ + "img/make.d6f77347.svg";